@if (loading() === true) {
    <app-loading-spinner></app-loading-spinner>
}

<router-outlet></router-outlet>
